/**
 * SDCX FUNC_TYPE(0x1f) 功能键 → 虚拟键盘展示码
 * code1 语义对齐公版驱动 / 智慧无限同类功能码
 */

/** 改键页 Fn 图标占位（与 KEYCODE_MAP 61697 一致） */
export const SDCX_FN_UI_KEYCODE = 61697;

export const SDCX_FN_SYNTHETIC_BASE = 0x01f00000;

/** 功能码 → 改键页图标码（与 KEYCODE_MAP 对齐） */
export const SDCX_FUNC_ICON_KEYCODE: Readonly<Record<number, number>> = {
  0x01: SDCX_FN_UI_KEYCODE,
  0x04: 61961,
  0x05: 61952,
  0x0d: 61953,
  0x0e: 61954,
  0x21: 62210,
  0x22: 62211,
  0x24: 62212,
  0x25: 62213,
  0x29: 62209,
  0x2b: 62215,
  0x2c: 62208,
  0x6e: 62224,
};

/** 改键页图标码 → 功能码（写入矩阵） */
export const SDCX_UI_ICON_TO_FUNC: Readonly<Record<number, number>> =
  Object.fromEntries(
    Object.entries(SDCX_FUNC_ICON_KEYCODE).map(([code, ui]) => [
      ui,
      Number(code),
    ])
  ) as Readonly<Record<number, number>>;

/** 功能码 → 中文名（Fn 层键帽文案兜底） */
export const SDCX_FUNC_NAME_MAP: Readonly<Record<number, string>> = {
  0x01: "Fn",
  0x04: "GUI锁定",
  0x05: "键盘复位",
  0x0d: "Windows设备",
  0x0e: "Mac设备",
  0x21: "亮度+",
  0x22: "亮度-",
  0x24: "速度+",
  0x25: "速度-",
  0x29: "颜色切换",
  0x2b: "灯光开关",
  0x2c: "切换灯效",
  0x6e: "游戏灯光图",
};

export function isSdcxFnSyntheticKeyCode(keyCode: number): boolean {
  return (
    Number.isFinite(keyCode) &&
    keyCode >= SDCX_FN_SYNTHETIC_BASE &&
    keyCode < SDCX_FN_SYNTHETIC_BASE + 0x01000000
  );
}

/** 功能键 / 图标码 / 合成码：Fn 层合并时识别「已映射 Fn 功能」 */
export function isSdcxFnDisplayKeyCode(keyCode: number): boolean {
  if (!keyCode) return false;
  if (keyCode === SDCX_FN_UI_KEYCODE) return true;
  if (isSdcxFnSyntheticKeyCode(keyCode)) return true;
  return Object.values(SDCX_FUNC_ICON_KEYCODE).includes(keyCode);
}

export function resolveSdcxFnFuncDisplayKeyCode(code1: number): number {
  if (code1 === 0x01) return SDCX_FN_UI_KEYCODE;
  const icon = SDCX_FUNC_ICON_KEYCODE[code1];
  if (icon != null) return icon;
  if (!code1) return 0;
  return SDCX_FN_SYNTHETIC_BASE | code1;
}

export function lookupSdcxFuncName(funcCode: number): string | undefined {
  return SDCX_FUNC_NAME_MAP[funcCode];
}
